import e from "./generateUtilityClasses.mjs";
import s from "./generateUtilityClass.mjs";
function a(t) {
  return s("MuiListItemText", t);
}
const i = e("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), m = i;
export {
  m as default,
  a as getListItemTextUtilityClass
};
//# sourceMappingURL=listItemTextClasses.mjs.map
